export default __webpack_public_path__ + "static/media/ture1.e8dd1755.png";